import * as React from "react";
const SvgCheckSmall = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.48 7.424a.75.75 0 0 1 .096 1.056l-6.667 8a.75.75 0 0 1-1.113.043l-3.334-3.429a.75.75 0 0 1 1.076-1.045l2.752 2.831 6.134-7.36a.75.75 0 0 1 1.056-.096Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgCheckSmall;
